import { baseURL } from "../../../../../config/Endpoints.js";

export const SQE_ONBOARDING = `${baseURL}/sqe/onboarding`;
export const SQE_PHASE2 = `${baseURL}/sqe/phase2`;

/** UI pages are one-based; SQE list APIs expect zero-based pages. */
export function sqePageParams(page: number, pageSize: number, status?: string): string {
  const params = new URLSearchParams({ page: String(Math.max(0, page - 1)), pageSize: String(pageSize) });
  if (status) params.set("status", status);
  return params.toString();
}

export function unwrapSqeData(value: unknown): unknown {
  if (!value || typeof value !== "object" || Array.isArray(value)) return value;
  const record = value as Record<string, unknown>;
  return record.data != null ? record.data : value;
}

export function sqeRows(value: unknown): { rows: Record<string, unknown>[]; totalPages: number; totalElements: number } {
  const body = unwrapSqeData(value);
  const block = body && typeof body === "object" && !Array.isArray(body)
    ? body as Record<string, unknown>
    : value && typeof value === "object" && !Array.isArray(value)
      ? value as Record<string, unknown>
      : {};
  const items = Array.isArray(body) ? body : Array.isArray(block.content) ? block.content : Array.isArray(block.data) ? block.data : [];
  const rows = items.filter((item): item is Record<string, unknown> => !!item && typeof item === "object" && !Array.isArray(item));
  return {
    rows,
    totalPages: typeof block.totalPages === "number" ? block.totalPages : 1,
    totalElements: typeof block.totalElements === "number" ? block.totalElements : rows.length,
  };
}

/** The pre-joining queue can contain an employee without a phase 2 record yet. */
export function normalizeSqePhase2Row(row: Record<string, unknown>): Record<string, unknown> {
  const nestedEmployee = row.employee && typeof row.employee === "object" && !Array.isArray(row.employee)
    ? row.employee as Record<string, unknown>
    : null;
  const employee = nestedEmployee ?? row;
  const employeeId = row.employeeId ?? employee.id;
  return {
    ...row,
    employee: nestedEmployee ?? (employeeId == null ? undefined : employee),
    employeeId,
    phase2Id: row.phase2Id ?? row.id ?? employeeId,
  };
}
